export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

export function formatData(arr) {
  return arr.map(item => {
    item.child = item.children || []
    delete item.children
    item.checkedList = []
    item.child.forEach(k => {
      if(k.checked){
        item.checkedList.push(k.id)
      }
    })
    // 模块/菜单是否需要全选
    if(item.child.length){
      formatData(item.child)
    }else{
      delete item.checkedList
    }
    return item
  })
}

export function getMenu(url,arr) {
  for(let i = 0; i < arr.length; i ++){
    if(arr[i].url === url){
      return arr[i]
    }else{
      if(arr[i].children && arr[i].children.length > 0){
        if(arr[i].children.find(a => a.url === url)){
          return arr[i].children.find(a => a.url === url)
        }
      }
    }
  }
}

